import React from 'react';

import { makeStyles, blend } from '@gogame/ui/styles';

export const HANDLE_WIDTH = 12;
const useHandleStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 0,
    left: 0,
    border: 'none',
    background: blend(
      theme.palette.background.default,
      theme.palette.action.active,
      theme.palette.action.hoverOpacity,
      1
    ),
    color: theme.palette.text.primary,
    width: HANDLE_WIDTH,
    cursor: 'grab',
    height: '100%',
    '&:after': {
      content: '"::"',
      position: 'absolute',
      top: '50%',
      left: '2.71px',
      transform: 'translateY(-50%)',
      color: theme.palette.text.primary,
    },
  },
}));

const Handle = React.forwardRef(({ children, ...props }, ref) => {
  const classes = useHandleStyles();
  return (
    <div ref={ref} className={classes.root} {...props}>
      {children}
    </div>
  );
});

export default Handle;
